// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

  #header .content {
    z-index: 4;
  }
  
  #header .content .nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  #header .content .btns .btn {
    padding: 0.5rem 1.2rem;
    border-radius: 2rem;
    margin: 0 0.5rem;
    color: white;
  }
  
  #header .content .btns .btn-mint {
    border: 1px solid white;
  }
  #header .content .btns .btn-connect {
    border: none;
    background: #f04225;
  }
  
  #header .content .centerText {
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  
  #header .content .centerText .title {
    font-size: clamp(4rem, 5vw, 106px);
    line-height: 10rem;
  }
  
  #header .content .centerText .desc {
    text-transform: uppercase;
    font-size: 24px;
    margin-top: -1rem;
  }
  
  #header .content .vertical-line {
    height: 22rem;
    width: 3px;
    border: none;
    margin-bottom: -10rem;
    color: black;
    background-color: black;
    background: black;
    opacity: 0.8;
  }

  /* .title{
    color: #6f6;
    font-family: 'Orbitron', Verdana, sans-serif;
    font-size: 2.2em;
    background: none;
  }

@-webkit-keyframes pulseText {
  0% {text-shadow: 0px 0px 8px rgba(0, 255, 0, 0.7);}
  100% {text-shadow: 0px 0px 22px rgba(0, 255, 0, 1);}
}
@-moz-keyframes pulseText {
  0% {text-shadow: 0px 0px 8px rgba(0, 255, 0, 0.7);}
  100% {text-shadow: 0px 0px 22px rgba(0, 255, 0, 1);}
}
@-o-keyframes pulseText {
  0% {text-shadow: 0px 0px 8px rgba(0, 255, 0, 0.7);}
  100% {text-shadow: 0px 0px 22px rgba(0, 255, 0, 1);}
}
@keyframes pulseText {
  0% {text-shadow: 0px 0px 8px rgba(0, 255, 0, 0.7);}
  100% {text-shadow: 0px 0px 22px rgba(0, 255, 0, 1);}
}
   */

.pulseText {
    animation-name: pulseText;
    animation-duration: 0.8s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-timing-function: ease-in-out;
    border: 0px;
  }


  /* CALL TO ACTION */
.call-to-action {
    background: white;

    color: white;
    display: grid;
    grid-template-columns: 1fr 2fr;
    padding: 1.25rem 3rem 1.9rem 3rem;
    
    height: 60%;
    font-family: "FS Sinclair Medium";
  }

  .hero-text {
    height: 80%;
  }
  .hero-text > h1 {
    font-size: 3rem;
    margin-top: 0rem;
   
  }
  
  .hero-text > h2 {
    font-size: 2.5rem;
  }
  
  .hero-image {
    max-height: 50rem;
    padding-left: 2rem;
  }
  
  .hero-image > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .custom-carousel {
    height: 400px;
  }


  .image-container {
    position: relative;
    width: 100%;
    height: 100%; 
  }
  
  
  .skeleton {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, #eee 25%, #ddd 50%, #eee 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    z-index: 1; 
  }
  
  @keyframes loading {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
  
  .caseStudyImg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    
  }
  
  .loading {
    display: none;
  }
  
  .loaded {
    display: block;
  }
  
  .hide {
    display: none;
  }

  .image-box {
    max-width: 100%;
    overflow: hidden;
    border-radius: 2% 2% 0 0;
  }
  
  .images {
   max-width: 100%;
    background-size: contain; 
    background-position: center center; 
    background-repeat: no-repeat;
    border-radius: 2% 2% 0 0;
    transition: all 1s ease;
    -moz-transition: all 1s ease;
    -ms-transition: all 1s ease;
    -webkit-transition: all 1s ease;
    -o-transition: all 1s ease;
    text-align: center;
    
  }

  .headerStyle {
    color: rgb(174, 33, 50);
  font-family: "FS Sinclair Medium";
  font-size: x-large;
  font-weight: bold;
  letter-spacing: 2px;
}

/* .carousel-fade .carousel-item {
  transition: opacity 1s ease; 
}
  
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right,
.carousel-fade .carousel-item.active {
  opacity: 0;
}

.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev,
.carousel-fade .carousel-item.active.carousel-item-left,
.carousel-fade .carousel-item.active.carousel-item-right {
  opacity: 1;
} */

.labelStyle {
  color: rgb(174, 33, 50);
  font-family: "FS Sinclair Medium";
  font-size: medium;
  font-weight: bold;
  letter-spacing: 1px;
}
/* .container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
} */

@media (max-width: 768px) {
  .carousel-section {
    order: -1; /* Move carousel above the text container on mobile */
  }
  .headerStyle {
    font-size: large; /* Smaller font size for smaller devices */
  }

  .labelStyle {
    font-size: small; /* Adjust label font size */
  }

  .call-to-action {
    grid-template-columns: 1fr; /* Stack elements vertically on smaller screens */
    padding: 1rem; /* Reduce padding */
  }

  .image-box, .images {
    height: auto; /* Adjust height for smaller devices */
  }

  .carousel .carousel-item {
    text-align: center; /* Center content in the carousel */
  }
}
  `, "",{"version":3,"sources":["webpack://./src/pages/caseStudies/CaseStudy.css"],"names":[],"mappings":";;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;EACd;;EAEA;;;;;;;;;;;;;;;;;;;;;;;IAuBE;;AAEJ;IAII,yBAAyB;IAIzB,wBAAwB;IAIxB,mCAAmC;IAInC,8BAA8B;IAI9B,sCAAsC;IACtC,WAAW;EACb;;;EAGA,mBAAmB;AACrB;IACI,iBAAiB;;IAEjB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,iCAAiC;;IAEjC,WAAW;IACX,iCAAiC;EACnC;;EAEA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;;EAElB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;;EAGA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gEAAgE;IAChE,0BAA0B;IAC1B,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;;EAErB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;GACC,eAAe;IACd,wBAAwB;IACxB,kCAAkC;IAClC,4BAA4B;IAC5B,wBAAwB;IACxB,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;IAC3B,+BAA+B;IAC/B,0BAA0B;IAC1B,kBAAkB;;EAEpB;;EAEA;IACE,uBAAuB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;;;;;GAMG;;AAEH;EACE;IACE,SAAS,EAAE,qDAAqD;EAClE;EACA;IACE,gBAAgB,EAAE,0CAA0C;EAC9D;;EAEA;IACE,gBAAgB,EAAE,2BAA2B;EAC/C;;EAEA;IACE,0BAA0B,EAAE,iDAAiD;IAC7E,aAAa,EAAE,mBAAmB;EACpC;;EAEA;IACE,YAAY,EAAE,sCAAsC;EACtD;;EAEA;IACE,kBAAkB,EAAE,mCAAmC;EACzD;AACF","sourcesContent":["\r\n\r\n  #header .content {\r\n    z-index: 4;\r\n  }\r\n  \r\n  #header .content .nav {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  #header .content .btns .btn {\r\n    padding: 0.5rem 1.2rem;\r\n    border-radius: 2rem;\r\n    margin: 0 0.5rem;\r\n    color: white;\r\n  }\r\n  \r\n  #header .content .btns .btn-mint {\r\n    border: 1px solid white;\r\n  }\r\n  #header .content .btns .btn-connect {\r\n    border: none;\r\n    background: #f04225;\r\n  }\r\n  \r\n  #header .content .centerText {\r\n    height: 100vh;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n  }\r\n  \r\n  #header .content .centerText .title {\r\n    font-size: clamp(4rem, 5vw, 106px);\r\n    line-height: 10rem;\r\n  }\r\n  \r\n  #header .content .centerText .desc {\r\n    text-transform: uppercase;\r\n    font-size: 24px;\r\n    margin-top: -1rem;\r\n  }\r\n  \r\n  #header .content .vertical-line {\r\n    height: 22rem;\r\n    width: 3px;\r\n    border: none;\r\n    margin-bottom: -10rem;\r\n    color: black;\r\n    background-color: black;\r\n    background: black;\r\n    opacity: 0.8;\r\n  }\r\n\r\n  /* .title{\r\n    color: #6f6;\r\n    font-family: 'Orbitron', Verdana, sans-serif;\r\n    font-size: 2.2em;\r\n    background: none;\r\n  }\r\n\r\n@-webkit-keyframes pulseText {\r\n  0% {text-shadow: 0px 0px 8px rgba(0, 255, 0, 0.7);}\r\n  100% {text-shadow: 0px 0px 22px rgba(0, 255, 0, 1);}\r\n}\r\n@-moz-keyframes pulseText {\r\n  0% {text-shadow: 0px 0px 8px rgba(0, 255, 0, 0.7);}\r\n  100% {text-shadow: 0px 0px 22px rgba(0, 255, 0, 1);}\r\n}\r\n@-o-keyframes pulseText {\r\n  0% {text-shadow: 0px 0px 8px rgba(0, 255, 0, 0.7);}\r\n  100% {text-shadow: 0px 0px 22px rgba(0, 255, 0, 1);}\r\n}\r\n@keyframes pulseText {\r\n  0% {text-shadow: 0px 0px 8px rgba(0, 255, 0, 0.7);}\r\n  100% {text-shadow: 0px 0px 22px rgba(0, 255, 0, 1);}\r\n}\r\n   */\r\n\r\n.pulseText {\r\n    -webkit-animation-name: pulseText;\r\n    -moz-animation-name: pulseText;\r\n    -o-animation-name: pulseText;\r\n    animation-name: pulseText;\r\n    -webkit-animation-duration: 0.8s;\r\n    -moz-animation-duration: 0.8s;\r\n    -o-animation-duration: 0.8s;\r\n    animation-duration: 0.8s;\r\n    -webkit-animation-iteration-count: infinite;\r\n    -moz-animation-iteration-count: infinite;\r\n    -o-animation-iteration-count: infinite;\r\n    animation-iteration-count: infinite;\r\n    -webkit-animation-direction: alternate;\r\n    -moz-animation-direction: alternate;\r\n    -o-animation-direction: alternate;\r\n    animation-direction: alternate;\r\n    -webkit-animation-timing-function: ease-in-out;\r\n    -moz-animation-timing-function: ease-in-out;\r\n    -o-animation-timing-function: ease-in-out;\r\n    animation-timing-function: ease-in-out;\r\n    border: 0px;\r\n  }\r\n\r\n\r\n  /* CALL TO ACTION */\r\n.call-to-action {\r\n    background: white;\r\n\r\n    color: white;\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr;\r\n    padding: 1.25rem 3rem 1.9rem 3rem;\r\n    \r\n    height: 60%;\r\n    font-family: \"FS Sinclair Medium\";\r\n  }\r\n\r\n  .hero-text {\r\n    height: 80%;\r\n  }\r\n  .hero-text > h1 {\r\n    font-size: 3rem;\r\n    margin-top: 0rem;\r\n   \r\n  }\r\n  \r\n  .hero-text > h2 {\r\n    font-size: 2.5rem;\r\n  }\r\n  \r\n  .hero-image {\r\n    max-height: 50rem;\r\n    padding-left: 2rem;\r\n  }\r\n  \r\n  .hero-image > img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .custom-carousel {\r\n    height: 400px;\r\n  }\r\n\r\n\r\n  .image-container {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%; \r\n  }\r\n  \r\n  \r\n  .skeleton {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(90deg, #eee 25%, #ddd 50%, #eee 75%);\r\n    background-size: 200% 100%;\r\n    animation: loading 1.5s infinite;\r\n    z-index: 1; \r\n  }\r\n  \r\n  @keyframes loading {\r\n    0% {\r\n      background-position: -200% 0;\r\n    }\r\n    100% {\r\n      background-position: 200% 0;\r\n    }\r\n  }\r\n  \r\n  .caseStudyImg {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n    \r\n  }\r\n  \r\n  .loading {\r\n    display: none;\r\n  }\r\n  \r\n  .loaded {\r\n    display: block;\r\n  }\r\n  \r\n  .hide {\r\n    display: none;\r\n  }\r\n\r\n  .image-box {\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    border-radius: 2% 2% 0 0;\r\n  }\r\n  \r\n  .images {\r\n   max-width: 100%;\r\n    background-size: contain; \r\n    background-position: center center; \r\n    background-repeat: no-repeat;\r\n    border-radius: 2% 2% 0 0;\r\n    transition: all 1s ease;\r\n    -moz-transition: all 1s ease;\r\n    -ms-transition: all 1s ease;\r\n    -webkit-transition: all 1s ease;\r\n    -o-transition: all 1s ease;\r\n    text-align: center;\r\n    \r\n  }\r\n\r\n  .headerStyle {\r\n    color: rgb(174, 33, 50);\r\n  font-family: \"FS Sinclair Medium\";\r\n  font-size: x-large;\r\n  font-weight: bold;\r\n  letter-spacing: 2px;\r\n}\r\n\r\n/* .carousel-fade .carousel-item {\r\n  transition: opacity 1s ease; \r\n}\r\n  \r\n.carousel-fade .carousel-item-next.carousel-item-left,\r\n.carousel-fade .carousel-item-prev.carousel-item-right,\r\n.carousel-fade .carousel-item.active {\r\n  opacity: 0;\r\n}\r\n\r\n.carousel-fade .carousel-item-next,\r\n.carousel-fade .carousel-item-prev,\r\n.carousel-fade .carousel-item.active.carousel-item-left,\r\n.carousel-fade .carousel-item.active.carousel-item-right {\r\n  opacity: 1;\r\n} */\r\n\r\n.labelStyle {\r\n  color: rgb(174, 33, 50);\r\n  font-family: \"FS Sinclair Medium\";\r\n  font-size: medium;\r\n  font-weight: bold;\r\n  letter-spacing: 1px;\r\n}\r\n/* .container {\r\n  width: 100%;\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n} */\r\n\r\n@media (max-width: 768px) {\r\n  .carousel-section {\r\n    order: -1; /* Move carousel above the text container on mobile */\r\n  }\r\n  .headerStyle {\r\n    font-size: large; /* Smaller font size for smaller devices */\r\n  }\r\n\r\n  .labelStyle {\r\n    font-size: small; /* Adjust label font size */\r\n  }\r\n\r\n  .call-to-action {\r\n    grid-template-columns: 1fr; /* Stack elements vertically on smaller screens */\r\n    padding: 1rem; /* Reduce padding */\r\n  }\r\n\r\n  .image-box, .images {\r\n    height: auto; /* Adjust height for smaller devices */\r\n  }\r\n\r\n  .carousel .carousel-item {\r\n    text-align: center; /* Center content in the carousel */\r\n  }\r\n}\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
